import React, {useState} from 'react';
import {Button, Form, Input} from 'antd';
import {MailOutlined} from '@ant-design/icons';
import {useAppDispatch, useAppState} from '@nutastic/nutastic-react-app';
import {logIntoApplication, quickCall} from '../../../state/actions.mjs';
import makeFetchCall from "../../../utils/makeFetchCall";
import classnames from "classnames";

const componentClass = 'accountValidationForm';

export const AccountValidationForm = ({ emailValue, onValidationComplete }) => {
    const appDispatch = useAppDispatch();
    const [isMakingCall, setIsMakingCall] = useState(false);
    const classes = classnames(componentClass, 'nuAntForm');

    const initialCredential = {
        email: emailValue || '',
    };

    const onLoginClick = ({ email }) => {
        const onComplete = (response) => {
            console.log('Validation Complete', response);
            const isValid = response?.result;
            setIsMakingCall(false);
            onValidationComplete && onValidationComplete(email, isValid);
        }
        appDispatch(quickCall({
            title: 'validating user',
            asyncFetchCall: async () => {
                return await makeFetchCall('/api/auth/validateEmail', { email: email })
            },
            onSuccess: onComplete,
            onError: onComplete
        }));
    };

    return <div className={componentClass}>
        <div className={`${componentClass}__message`}>
            <h2>Enter Your Email</h2>
            <p>Enter your email below and click continue. If you don't have an account with us, enter an email you would like to use for your Nu Account!</p>
        </div>
        <Form layout="vertical" initialValues={initialCredential} onFinish={onLoginClick}>
            <Form.Item name="email" rules={[{ required: true, message: 'Enter your email', type: 'email' }]}>
                <Input prefix={<MailOutlined className="text-primary"/>} placeholder="user@nutastic.net"/>
            </Form.Item>
            <Form.Item className="mt-5">
                <button type="submit" className="btn btn-primary btn-block" disabled={isMakingCall}>Continue</button>
            </Form.Item>
        </Form>
    </div>;
};

export default AccountValidationForm;
